import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HostTripRouteDetailsService } from './host-trip-route-details.service';


const HOST_PROFILE_TYPE = 'host';

@Component({
    selector: 'app-host-trip-route-details',
    templateUrl: './host-trip-route-details.component.html'
})
export class HostTripRouteDetailsComponent implements OnInit, OnChanges {

    @Input() data: any;
    public info: any = {};
    public tripRequestDetails: any;
    constructor(
        public dialog: MatDialog,
        public hostTripRequestRouteDetailsService: HostTripRouteDetailsService,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data && changes.data.currentValue) {
            this.data = changes.data.currentValue;
            if (this.data.dataFetched) {
                this.getTripRouteRequestDetail(() => {
                    this.constructCard();
                });
            } else {
                this.blankCard();
            }
        } else {
            this.emptyCard();
        }
    }

    ngOnInit() { }

    blankCard() {
        this.info = {
            header: 'Trip Route Details',
            data: [],
            dataFetched: false
        };
    }

    emptyCard() {
        this.info = {
            header: 'Trip Route Details',
            dataFetched: false,
            data: null
        };
    }

    constructCard() {
        if (this.tripRequestDetails && this.tripRequestDetails.dataFetched) {
            let ellipsisMenu = [];
            const createdAt = new Date(this.tripRequestDetails.createdAt).toLocaleString();
            const startTime = this.tripRequestDetails.schedule.startTime;
            const returnTime = this.tripRequestDetails.schedule.returnTime;
            const formattedDays = this.formatDaysOfWeek(this.tripRequestDetails.schedule.daysOfWeek);

            
            this.info = {
                header: 'Trip Route Details',
                ellipsis: ellipsisMenu,
                dataFetched: true,
                data: [
                    { header: 'Pickup', value: this.tripRequestDetails.location.start.name, className: 'id-icon', svgIcon: true },
                    { header: 'Start Time', value: startTime, className: 'last-used-device-icon', svgIcon: true },
                    { header: 'Drop', value: this.tripRequestDetails.location.end.name, className: 'id-icon', svgIcon: true },
                    { header: 'Return Time', value: returnTime, className: 'last-used-device-icon', svgIcon: true },
                    { header: 'Pickup Location', value: this.tripRequestDetails.location.start.address, className: 'id-icon', svgIcon: true },
                    { header: 'Drop Location', value: this.tripRequestDetails.location.end.address, className: 'id-icon', svgIcon: true },
                    { header: 'Days of Week', value: formattedDays, className: 'id-icon', svgIcon: true },
                    { header: 'Creation Time', value: createdAt, className: 'last-used-device-icon', svgIcon: true },
                ]
            };
        }
    }

    private formatDaysOfWeek(daysOfWeek: string[]): string {
        if (!daysOfWeek || daysOfWeek.length === 0) {
            return 'N/A';
        }

        const dayMap = {
            'monday': 'Mon',
            'tuesday': 'Tue', 
            'wednesday': 'Wed',
            'thursday': 'Thu',
            'friday': 'Fri',
            'saturday': 'Sat',
            'sunday': 'Sun'
        };

        const formattedDays = daysOfWeek.map(day => dayMap[day.toLowerCase()] || day);
        return formattedDays.join(', ');
    }

    accessCookie(cookieName) {
        const name = cookieName + '=';
        const allCookieArray = document.cookie.split(';');
        for (let i = 0; i < allCookieArray.length; i++) {
            const temp = allCookieArray[i].trim();
            if (temp.indexOf(name) === 0) {
                return temp.substring(name.length, temp.length);
            }
        }
        return '';
    }

    getTripRouteRequestDetail(callback: () => void) {
        const guestProfileId = this.data.profiles.filter(profile => profile.type === HOST_PROFILE_TYPE)[0].id;
        this.hostTripRequestRouteDetailsService.getTripRouteRequestDetails(guestProfileId).subscribe(
            (result: { data: any[] }) => {
                if (result && result.data.length > 0) {
                    this.tripRequestDetails = result.data[0];
                    this.tripRequestDetails.dataFetched = true;
                } else {
                    this.tripRequestDetails = { dataFetched: false };
                }
                callback();
            },
            error => {
                console.error('Error fetching trip route request details:', error);
                this.tripRequestDetails = { dataFetched: false };
                callback();
            }
        );
    }
}
